export var THUMBNAIL_LIST_EARS = 30;